module.exports = __webpack_public_path__ + "media/6.3cabea9f.mp3";